import { render, staticRenderFns } from "./Nothing.vue?vue&type=template&id=dc2a0ca0&scoped=true"
import script from "./Nothing.vue?vue&type=script&lang=js"
export * from "./Nothing.vue?vue&type=script&lang=js"
import style0 from "./Nothing.vue?vue&type=style&index=0&id=dc2a0ca0&prod&lang=scss&scoped=true"
import style1 from "./Nothing.vue?vue&type=style&index=1&id=dc2a0ca0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc2a0ca0",
  null
  
)

export default component.exports